import { Box, Grid, Typography, useMediaQuery } from '@mui/material'
import Title from '../../components/common/title'
import { MRT_ColumnDef, MRT_SortingState } from 'material-react-table'
import useSelectedItemSideBar from '../../hooks/useSelectedItemSideBar'
import { useState } from 'react'
import CustomTable from '../../components/common/customTable'
import OpenCloseArrowIcon from '../../icons/openCloseArrowIcon'
import {  useGetEventsQuery } from '../../hooks/api/events'
import {EventsType, activities} from '../../types/api/events'
import {getDate} from '../../utils'

const MyEvents = () => {
  const isMobile = useMediaQuery('(max-width:800px)')

  const [selectedTitle, setSelectedTitle] = useState('')
  const [page, setPage] = useState('1')
  const [sorting, setSorting] = useState<MRT_SortingState>([{ id:'start_date', desc: true }])
  const {data , isFetching} = useGetEventsQuery({
    page,
    sort: sorting[0],
  })

  useSelectedItemSideBar('events.myEvents');

  const DateTitle = () => <Box sx={{ pl: '15px' }}>Date</Box>
  const DateBody = ({ row }: any) => (
    <Typography variant='smallTextNormal' pl='15px'>
      {getDate(row.original.start_date, row.original.end_date)}
    </Typography>
  )

  const EventTitle = () => <Box sx={{ pl: isMobile ? '20px' : 0 }}>événement</Box>

  const TitleBody = ({ row }: any) => (
    <Box sx={{ pl: isMobile ? '20px' : 0 }}>
      <Typography
        variant='h6'
        component='a'
        href={`${process.env.REACT_APP_ACQ_SITE}/entrepreneurs/evenements/${row.original.crm_id}`}
        target='_blank'
        sx={{ textDecoration: 'underline', cursor: 'pointer' }}
      >
        {row.original.title}
      </Typography>
    </Box>
  )
  const DetailPanel = ({ row }: any) => (
    <Box           
    sx={{
      display: 'flex',
      flexDirection:'column',
      gap:'20px',
      width: '100%',
      maxWidth: '100%',
      p: '20px',
      backgroundColor: '#f8f9fa',
      borderRadius: '8px',
      margin: '10px 0',
      overflow: 'hidden',
      boxSizing: 'border-box',
    }}>
    {row.original.activities && row.original.activities.map((item: activities, index: number) => (
          <Box
          key={index}
          sx={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: 'flex-start',
            width: '100%',
            maxWidth: '100%',
            gap: isMobile ? '12px' : '24px',
            borderBottom: index < row.original.activities.length - 1 ? '1px solid #e0e0e0' : 'none',
            paddingBottom: index < row.original.activities.length - 1 ? '16px' : '0',
            overflow: 'hidden',
          }}
        >
            <Box sx={{ 
              minWidth: isMobile ? '100%' : '220px', 
              maxWidth: isMobile ? '100%' : '220px',
              marginBottom: isMobile ? '8px' : '0',
              flexShrink: 0,
            }}>
                <Typography variant='h6' sx={{ 
                  fontWeight: 'bold',
                  color: '#333',
                  fontSize: '16px',
                  wordBreak: 'break-word',
                }}>
                  {item.title}
                </Typography>
            </Box>
            
            {item.participants && item.participants.length > 0 && (
            <Box sx={{ 
              flex: 1,
              minWidth: 0,
              overflow: 'hidden',
            }}>
                <Box sx={{ 
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '4px',
                  width: '100%',
                }}>
                  {item.participants.map((participant: string, participantIndex: number) => (
                    <Typography 
                      key={participantIndex} 
                      variant='smallTextNormal' 
                      sx={{ 
                        padding: '4px 0',
                        color: '#555',
                        fontSize: '14px',
                        wordBreak: 'break-word',
                        overflow: 'hidden',
                      }}
                    >
                      • {participant}
                    </Typography>
                  ))}
                </Box>
            </Box>
            )}
        </Box>
    ))}  

  </Box>
  )
  const ExpandBody = ({ row }: any) => (
    <Box
      onClick={() => row.toggleExpanded()}
      sx={{
        cursor: 'pointer',
        p: '5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '9px',
      }}
    >
      <Typography variant='smallTextNormal'>Voir les participants</Typography>
      <OpenCloseArrowIcon open={row.getIsExpanded()} />
    </Box>
  )
  const columns: MRT_ColumnDef<EventsType>[] = [
    {
      accessorKey: 'start_date',
      header: 'Date',
      Header: DateTitle,
      enableSorting: true,
      Cell: DateBody,
    },

    {
      accessorKey: 'title',
      header: 'événement',
      Header: EventTitle,
      enableSorting: true,
      Cell: TitleBody,
    },
  ]

  return (
    <>
      <Title sx={{ mb: '48px' }}>mes événements</Title>
      <CustomTable
        muiTableBodyRowProps={({ row, isDetailPanel }) => ({
          sx: {
            ...(isDetailPanel &&
              !row.getIsExpanded() && {
                height: '0px',
                overflow: 'hidden',
              }),
          },
          hover: false,
        })}
        data={data?.data??[]}
        columns={columns}
        enableSorting={true}
        enableExpandAll={false}
        renderDetailPanel={DetailPanel}
        enableColumnResizing={false}
        displayColumnDefOptions={{
          'mrt-row-expand': {
            size: 41,
            maxSize: 41,
            minSize: 41,
            header: '',
            muiTableBodyCellProps: ({ row }) => ({
              sx: {
                px: '0',
                justifyContent: 'end',
                borderBottom: '1px solid #DADCDD',
                ...(row.getIsExpanded() ? { borderBottom: 'none' } : {}),
              },
            }),
            Cell: ExpandBody,
          },
        }}
        muiTableDetailPanelProps={({ row }) => ({
          sx: {
            width: '100%',
            pt: '3px',
            '& .MuiCollapse-root': {
              width: '100%',
            },
            ...(row.getIsExpanded() ? { pb: '36px' } : {}),
          },
        })}
        state={{ sorting, isLoading: isFetching }}
        enableExpanding
        enableSortingRemoval={false}
        enableMultiSort={false}
        manualSorting
        propsPagination={{
          page: Number(page),
          count: data?.metadata?.total && (Number(data.metadata.total) > 0) ? Math.ceil(Number(data.metadata.total) / 10) : 1,
          onChange: (e, index) => {
            setPage(index.toString())
          },
        }}
        onSortingChange={(params) => {
          setPage('1')
          setSorting(params)
        }}
      />
    </>
  )
}

export default MyEvents
